import { useDispatch, useSelector } from "react-redux";
import { loadingApplication } from "../redux/actions";
import { applicationSelector } from "../redux/selectors";
import { NonNullableRecognitionApplicationState } from "../redux/state";

export const useApplicationState = (
  orgId: string | null | undefined,
  applicationId: string
) => {
  const dispatch = useDispatch();
  const applicationState = useSelector(applicationSelector);

  if (!orgId) {
    return null;
  }

  const isCorrectRecordInRedux =
    applicationState.application &&
    String(applicationState.application.id).toLowerCase() === applicationId.toLowerCase();

  if (!isCorrectRecordInRedux && applicationState.status !== "LOADING") {
    dispatch(loadingApplication(orgId, applicationId));
  }

  return isCorrectRecordInRedux
    ? (applicationState as NonNullableRecognitionApplicationState)
    : null;
};
